import { useEffect } from 'react';

const PubliftPageInit = () => {
    useEffect(() => {
        const fusetag = window.fusetag || (window.fusetag = { que: [] });
        fusetag.que.push( function() {
            fusetag.pageInit();
        } );
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default PubliftPageInit;
